import { render } from "./ContactForm.vue?vue&type=template&id=bf869da0&scoped=true"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import "./ContactForm.vue?vue&type=style&index=0&id=bf869da0&lang=scss&scoped=true"

import exportComponent from "C:\\projets\\rivha\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf869da0"]])

export default __exports__